
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {State} from './state';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class StateService
{
  constructor(private http: HttpClient) { 
    }
    stateurl = environment.appURL+"/states";

 getStates() 
{
  return this.http.get<State[]>(this.stateurl,{headers: new HttpHeaders({"Authorization":"Bearer " + environment.token})})
  .pipe(
      tap(_ => {}),
    catchError(this.handleError('getStates', []))
  );
}

getState(id: number)
{
  const url = `${this.stateurl}/${id}`;

  return this.http.get<State>( url,{headers: new HttpHeaders({"Authorization":"Bearer " + environment.token})})
  .pipe(
    tap(_ => {}),
    catchError(this.handleError<State>(`getState id=${id}`))
  );
 }


 updateState (state: State): Observable<any> {
   let upd = "state=" + state.statevalue; 
  return this.http.put(this.stateurl +"/"+ state.id, upd , {headers: new HttpHeaders({"Authorization":"Bearer " + environment.token, "Content-Type": "application/x-www-form-urlencoded"})})
  .pipe(
    tap(_ => {}),
    catchError(this.handleError<any>('updateState'))
  );
}


private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}